import { TApplicationState } from '../../types/redux';
import { getHouses } from '../newbuilding/getHouses';
import { getSelectedHouseId } from './getSelectedHouseId';

export function isHouseNameVisible(state: TApplicationState) {
  return getHouses(state).length > 1 && !getSelectedHouseId(state);
}
